import { Injectable } from '@angular/core';

import { API_ENDPOINT } from '@careconne/core/configs';
import { DeletePlanDTO } from '@careconne/core/models/dto/careconne-company.dto';

import { ApiService } from '../common';

@Injectable({
  providedIn: 'root',
})
export class CareconneCompanyService {
  constructor(private readonly http: ApiService) {}

  getInfoSentOffices() {
    return this.http.get(
      `${API_ENDPOINT.CARECONNE_COMPANY.CONTROLLER}/${API_ENDPOINT.CARECONNE_COMPANY.GET_INFOSENT_OFFICES}`,
    );
  }

  getPlanSignAgreeList(careconneCompanyId: number) {
    return this.http.get(
      `${API_ENDPOINT.CARECONNE_COMPANY.CONTROLLER}/${API_ENDPOINT.CARECONNE_COMPANY.GET_PLAN_SIGN_AGREE_LIST}/${careconneCompanyId}`,
    );
  }

  deletePlan(data: DeletePlanDTO) {
    return this.http.post(
      `${API_ENDPOINT.CARECONNE_COMPANY.CONTROLLER}/${API_ENDPOINT.CARECONNE_COMPANY.DELETE_PLAN}`,
      data,
    );
  }

  getInfoSentOfficeDai() {
    return this.http.get(
      `${API_ENDPOINT.CARECONNE_COMPANY.CONTROLLER}/${API_ENDPOINT.CARECONNE_COMPANY.GET_INFOSENT_OFFICE_DAI}`,
    );
  }
}
